export type ConversationScope = {surface: 'chat'; id: string | null}

export function shouldResetForScopeChange(
  previousScope: ConversationScope | undefined,
  nextScope: ConversationScope,
): boolean {
  if (previousScope === undefined) return false
  return previousScope.id !== null && previousScope.id !== nextScope.id
}
